import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
// import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import Aggregated_traffic_analysis from "../../Assets/Projects/Aggregated_traffic_analysis.png";
import car_hub_nextjs from "../../Assets/Projects/car_hub_nextjs.png";
import dashboard_nextjs from "../../Assets/Projects/dashboard_nextjs.png";
import ip_address_tracker from "../../Assets/Projects/ip_address_tracker.png";
import Todo_list from "../../Assets/Projects/Todo_list.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col lg={4} md={6} sm={6} xs={12} className="project-card">
            <ProjectCard
              imgPath={car_hub_nextjs}
              isBlog={false}
              title="Car Hub - Find, Book or Rent a Car"
              description="I have spearheaded the development of a sophisticated web-based application leveraging Next.js, TypeScript, Tailwind CSS and PostgreSQL aimed at revolutionizing the car rental experience. Our platform offers seamless navigation through an extensive selection of vehicles, allowing users to effortlessly locate their desired car through advanced filtering options such as car name, model, fuel type (including diesel, electric, or CNG), and production year. The application provides a comprehensive overview of each car's key details, with the option to access additional information through a user-friendly popup interface. To enhance user experience and optimize performance, pagination functionality and server-side rendering have been meticulously implemented, ensuring swift and efficient browsing for our esteemed clientele."
              ghLink="#"
              demoLink="https://cars-hub-jet.vercel.app/"
              tags={[
                "NextJS",
                "TypeScript",
                "PostgreSQL",
                "Tailwind CSS",
                "Prisma",
                "Vercel",
                "Github",
              ]}
            />
          </Col>
          <Col lg={4} md={6} sm={6} xs={12} className="project-card">
            <ProjectCard
              imgPath={dashboard_nextjs}
              isBlog={false}
              title="Ecommerce App Dashboard"
              description="I have developed an ecommerce dashboard utilizing Next.js, Prisma, and PostgreSQL, providing users with a comprehensive overview of essential business metrics. This includes monitoring total revenue, managing invoices (both collected and pending), and analyzing customer data. The dashboard features a dynamic revenue graph for visualizing recent trends, along with a display of the latest invoices to facilitate quick access to transaction details. Designed to enhance decision-making and operational efficiency, this dashboard offers valuable insights for optimizing business performance and fostering growth in the ecommerce sector."
              ghLink="#"
              demoLink="https://dashboard-nextjs-lac.vercel.app/dashboard"
              tags={[
                "NextJS",
                "TypeScript",
                "Tailwind CSS",
                "PostgreSQL",
                "Prisma",
                "Vercel",
                "Github",
              ]}
            />
          </Col>
          <Col lg={4} md={6} sm={6} xs={12} className="project-card">
            <ProjectCard
              imgPath={ip_address_tracker}
              isBlog={false}
              title="IP Address Tracker"
              description="Discover comprehensive details about your IP address effortlessly with our React JS-based IP Address Tracker app. It automatically fetches and presents information such as IP address, location, timezone, and Internet Service Provider details. The app also features a user-friendly search bar for manual IP address exploration. Simplify your IP tracking experience with our professional and intuitive solution."
              ghLink="#"
              demoLink="https://user-ip-address-tracker.netlify.app/"
              tags={[
                "ReactJS",
                "JavaScript",
                "Bootstrap",
                "JSX",
                "CSS",
                "API's Integration",
              ]}
            />
          </Col>
          <Col lg={4} md={6} sm={6} xs={12} className="project-card">
            <ProjectCard
              imgPath={Todo_list}
              isBlog={false}
              title="Task Flow PRO"
              description="The React TodoList app streamlines task management, allowing users to effortlessly add, delete, and mark tasks as completed. It provides a real-time overview of both completed and outstanding tasks, fostering productivity and organization. Upon completing all tasks, a congratulatory message is displayed, celebrating the user's achievements in maintaining a well-organized to-do list."
              ghLink="#"
              demoLink="https://todolist-activity-tracker.netlify.app/"
              tags={[
                "ReactJS",
                "JavaScript",
                "Bootstrap",
                "JSX",
                "CSS",
                "Github",
              ]}
            />
          </Col>
          <Col lg={4} md={6} sm={6} xs={12} className="project-card">
            <ProjectCard
              imgPath={Aggregated_traffic_analysis}
              isBlog={false}
              title="User Activity and Traffic Analysis"
              description="I developed a comprehensive User Activity Tracker using React.js, JSX, CSS and Ant Design for the frontend, coupled with JavaScript and MySQL for the backend. This tool efficiently captures and analyzes user interactions on websites, including click tracking, landing page analysis, event tracking, stay time analysis, session tracking, and referral tracking. The recorded data is seamlessly stored in a MySQL database and dynamically displayed on the website through distinct tables for each category. The tool goes further by providing graphical representations, offering insights into user sessions, customer traffic by source/page, and highlighting the top 50 searched products for in-depth analysis. This project empowers businesses with valuable user behavior insights, aids in strategic decision-making, optimizes the overall user experience, and provides key insights into product search trends."
              ghLink="#"
              demoLink="#"
              tags={[
                "ReactJS",
                "NodeJS",
                "ExpressJS",
                "JavaScript",
                "AWS",
                "AntDesign",
                "MySql",
                "CSS",
                "Github",
              ]}
            />
          </Col>
          <Col lg={4} md={6} sm={6} xs={12} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Personal Portfolio"
              description="Personal Portfolio website Build using ReactJS, CSS and Bootstrap. Having different Sections i.e. Home, About, Projects & Resume. I can add my Projects, Skills, Tools that i am using, Days i code and Resume to my portfolio."
              ghLink="#"
              demoLink="https://hamza-ayoub.netlify.app/"
              tags={[
                "ReactJS",
                "NodeJS",
                "Express.JS",
                "JavaScript",
                "Bootstrap",
                "CSS3",
                "MySql",
                "ReactIcons",
              ]}
            />
          </Col>
          <Col lg={4} md={6} sm={6} xs={12} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="CRUD Operation in React JS"
              description="My own project for empolyee management system build using ReactJS. In this project i practice & learn React Js in detail. I have implemented CRUD operation by Create, Update, Delete of employees record."
              ghLink="#"
              demoLink="#"
              tags={[
                "ReactJS",
                "NodeJS",
                "Express.JS",
                "JavaScript",
                "Bootstrap",
                "CSS3",
                "MySql",
              ]}
            />
          </Col>
          <Col lg={4} md={6} sm={6} xs={12} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Hankering Dashboard"
              description="Website build with Php, Html, CSS, Bootstrap and MySql. Which register the user by taking some details then user can post to their feed  with their new campeign content. Content may be Clothing, Shoes or food product. All the content is saved to database and display to Mobile App. Admin has control of each & every thing."
              ghLink="#"
              demoLink="#"
              tags={[
                "HTML5",
                "CSS3",
                "MySQL",
                "Bootstrap",
                "PHP",
                "JavaScript",
                "JQuery",
              ]}
            />
          </Col>

          <Col lg={4} md={6} sm={6} xs={12} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="OneSkill Website"
              description="Website for Online Courses & Projects build using Django, HTML, CSS, Bootstrap & PostgreSql. This website Register Users and Trainers for different courses and trainings. After Registration user can enroll into different courses by selecting trainer of their choice. Courses are added by admin through Admin Panel. Admin can also Approve user status & have a record of Fees."
              ghLink="#"
              demoLink="https://oneskill.com.pk/"
              tags={[
                "HTML",
                "CSS",
                "Bootstrap",
                "Django",
                "PostgreSql",
                "Python",
              ]}
            />
          </Col>
          <Col lg={4} md={6} sm={6} xs={12} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Smart Tourism & Hospitality"
              description="Website for Online Tours booking build with Django, PostgreSql,Html, Css and Bootstrap. Have features which allows user to check & book tour of any city according to their budget, User have to provide some details e.g. Budget and total Holidays, then the system will suggest some places to visit in Pakaistan according to their Budget. it also provide facility of Local guide to the tourists. Tour Packages and local guides are added & manages by admin."
              ghLink="#"
              demoLink="#"
              tags={[
                "HTML5",
                "CSS3",
                "Bootstrap",
                "Django",
                "PostgreSql",
                "Python",
              ]}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
